export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_12.7c57ee98.jpg";